export enum ScrollDirection {
    Top,
    Bottom,
    None
}